module.exports = __webpack_public_path__ + "img/header_bg.a2acea93.png";